<template>
	<div class="complements">
		<h2 class="text-uppercase text-center no-padding" v-if="render_complements.length">Complementos</h2>
		<div class="flexible" v-if="render_complements.length">
			<div class="complements-item" v-for="product in render_complements.slice(0, 3)" v-link="{ path: '/product/' + convertToUrl(product) }">
				<span class="item-card-discount" v-if="parseInt(product.discount_percentage)">{{ parseInt(product.discount_percentage) }}%</span><br/>
				<img class="img-responsive center-block" :src="(product.images.length) ? product.images[0].route : image" alt="prod">
				<span class="item-card-name">{{ product.name }}</span><br>
				<span class="fa-stack fa-lg pull-right" :class="{ 'disabled': product.stock == 0 }">
					<i class="fa fa-circle fa-stack-2x"></i>
					<i class="fa fa-shopping-cart fa-stack-1x fa-inverse" @click="addProduct(user, product)"></i>
				</span>
				<stars :rating="product.rating"></stars>
				<div class="frow fbottom">
					<span class="item-gray" v-if="parseInt(product.discount_percentage)"><s>${{ accounting.formatMoney(product.original_price, '') }}</s></span>
					<span class="item-blue">${{ accounting.formatMoney((product.original_price - (product.original_price * (product.discount_percentage / 100))).toFixed(2), '') }}</span>
				</div>
			</div>
		</div>

		<div v-if="!render_complements.length" class="empty text-center">No hay complementos disponibles para este producto.</div>
	</div>
</template>

<script>
import Stars from './Product-detail-rate-stars.vue';
import { api_base } from '../../store/api';
import { addProductShoppingCart } from '../../store/actions';
import { convertToUrl } from '../../scripts/convert_name';
import default_image from '../../images/default.jpg';
import accounting from '../../scripts/accounting';

export default {
	data() {
		return {
			image: default_image,
			api_base,
			accounting
		};
	},

	vuex: {
		getters: {
			user: state => state.current_user,
			product: state => state.current_product
		},
		actions: {
			addProductShoppingCart
		}
	},

	components: {
		Stars
	},

	methods: {
		addProduct (user, product) {
			if (product.stock != 0) {
				return this.addProductShoppingCart(user, product);
			}

			toast({
				title: 'Carrito de Compras',
				content: 'Producto agotado'
			});
		},
		convertToUrl
	},

	computed: {
		render_complements() {
			return this.product.complements || [];
		}
	},
}
</script>



// WEBPACK FOOTER //
// Complements.vue?fe51240a